// react
import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
import Api from '@/api'
import {AppType} from '@/enum'

/**
 * 致远薪事力配置表单项
 * @constructor
 */
const SeeyonEhrFormItems = () => {
  return (
    <>
      <ProFormText
        name={["config", "account"]}
        label={"Account"}
        placeholder={"请输入account"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入account"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "password"]}
        label={"Password"}
        placeholder={"请输入password"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入password"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "userId"]}
        label={"AdminUserId"}
        placeholder={"请输入adminUserId"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入adminUserId"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "seeyonLoginType"]}
        label={"LoginType"}
        placeholder={"请输入LoginType"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入LoginType"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "serverUrl"]}
        label={"ServerUrl"}
        placeholder={"请输入serverUrl"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入serverUrl"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />
    </>
  )
}

export default SeeyonEhrFormItems
